export const Env = {
    REACT_APP_NODE_ENV: window.REACT_APP_NODE_ENV || process.env.REACT_APP_NODE_ENV,
    REACT_APP_API_BASE_URL: window.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
    REACT_APP_WEB_SOCKET: window.REACT_APP_WEB_SOCKET || process.env.REACT_APP_WEB_SOCKET,
};

